export const primaryColor = '#163979';
export const primaryColorDark = '#0c244f';
export const secondaryColor = '#3D965A';

export const infoColor = '#27aeda';
export const infoColorLight = '#f3fcff';
export const errorColor = '#ff2e51';
export const errorColorDark = '#a50f28';
export const errorColorLight = '#FF8492';
export const errorColorLighter = '#ce8483';
export const successColor = '#3D965A';
export const successColorDark = '#156f32';
export const warnColor = '#ffbf2f';
export const warnColorDark = '#b57d00';

export const secondaryInfoColor = '#d1722f';
export const infoGrey = '#6c757d';
export const greyDark = '#707070';
export const grey = '#B3B3B3';
export const greyLight = '#eee';
export const greyLighter = '#f5f5f5';
export const greyLightest = '#f7f7f7';

// Mainly webshop palette
export const blue = '#233C78';
export const lightBlue = '#6172A0';
export const lighterBlue = '#2D7BB4';
export const lightestBlue = '#BFE5F4';
export const darkGrey = '#5B5B5B';
export const detailGrey = '#6E6E6E';
export const lightGrey = '#767676';
export const lighterGrey = '#848484';
export const green = '#3D965A';
export const red = '#ED1C24';

export const darkBlue = '#253c7e';
export const backgroundGrey = '#E9EAEA';
export const textGrey = '#313131';

export const smallGap = '8px';
export const mediumGap = '16px';
export const largeGap = '24px';
